export const SET_HOME_TRENDS = "SET_HOME_TRENDS";
export const SET_PARK_TRENDS = "SET_PARK_TRENDS";
export const SET_SELECTED_ASSETS = "SET_SELECTED_ASSETS";
export const TOGGLE_SELECT_FILTERED_ASSETS = "TOGGLE_SELECT_FILTERED_ASSETS";
export const SET_SELECTED_ASSETS_MODEL = "SET_SELECTED_ASSETS_MODEL";
export const SET = "SET";
export const SHOW_TOAST = "SHOW_TOAST";
export const RESET_STATE = "RESET_STATE";
export const GET_CURRENT_TURBINE = "GET_CURRENT_TURBINE";